import { render, staticRenderFns } from "./EventProgramTableItemSpeaker.vue?vue&type=template&id=14ea23ff&scoped=true"
import script from "./EventProgramTableItemSpeaker.vue?vue&type=script&lang=js"
export * from "./EventProgramTableItemSpeaker.vue?vue&type=script&lang=js"
import style0 from "./EventProgramTableItemSpeaker.vue?vue&type=style&index=0&id=14ea23ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ea23ff",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CraftLink: require('/builds/gladwell/gladwell-academy-frontend/components/CraftLink.vue').default})
